/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_toolbox } from "../../App/actions/toolboxActions";

/*PICTURE*/
import ICON_CHECK from "../../Assets/jsx/ICON_CHECK";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const delay_close = 200; //milisecond

const GRID_SELECT_LAYER = ({
  toolbox,
  auth,
  set_value_toolbox,
  toggle_select,
}) => {
  const on_click_layer = (layer_id) => {
    const key =
      toolbox.select_mode === "point" ? "layer_point_id" : "layer_polygon_id";

    if (layer_id) {
      const { toolbox_grid_object } = toolbox;
      toolbox_grid_object[key] = layer_id;

      set_value_toolbox({
        key: "toolbox_grid_object",
        value: toolbox_grid_object,
      });
    }
    setTimeout(() => {
      toggle_select();
    }, delay_close);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const {
    layer_list_point_filtered,
    layer_list_polygon_filtered,
    toolbox_grid_object,
    select_mode,
  } = toolbox;

  //content
  const { layer_point_id, layer_polygon_id } = toolbox_grid_object;
  let array = [];
  let layer_id;
  if (select_mode === "point") {
    array = layer_list_point_filtered;
    layer_id = layer_point_id;
  } else {
    array = layer_list_polygon_filtered;
    layer_id = layer_polygon_id;
  }

  return (
    <main>
      <section className="max_height">
        <h1 className="margin_bottom">{dict?.["Select layer"]?.[language]}</h1>
        {array.map((item, idx) => {
          return (
            <div key={idx}>
              <button
                className="button_pill background_grey_light margin_bottom"
                onClick={() => on_click_layer(item?._id)}
              >
                <span
                  className={`badge_circle margin_right ${
                    layer_id === item._id
                      ? "background_black"
                      : "background_white"
                  }`}
                >
                  {layer_id === item._id && <ICON_CHECK fill="#fff" />}
                </span>
                <span className="margin_right">{item?.name}</span>
              </button>
            </div>
          );
        })}
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  toolbox: state.toolbox,
  map: state.map,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, { set_value_toolbox })(
  GRID_SELECT_LAYER
);
